// Segmented Toggle Component
const SpecialToggle = ({ activeOption, onToggle, options }) => {
    return (
        <div className="flex bg-gray-200 rounded-lg p-1 shadow-sm">
            {options.map((option, index) => (
                <button
                    key={option.value}
                    onClick={() => onToggle(option.value)}
                    className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all duration-200 ${
                        activeOption === option.value
                            ? 'bg-white shadow-sm text-black font-medium'
                            : 'text-gray-600 hover:text-gray-800'
                    }`}
                >
                    {option.icon}
                    <span className="text-sm !text-black">{option.label}</span>
                </button>
            ))}
        </div>
    );
};

export default SpecialToggle;